import nBossConnection from 'modules/base/service/nBossConnection';

class TaskManagerService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'taskControl';
	}

	/**
	 * @return {Promise<NamedDto[]>}
	 */
	getListSelection() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getListSelection`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {string} optimCaseName
	 * @return {Promise<string>}
	 */
	addOptimCase(optimCaseName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/addOptimCase`, {
					optimCaseName,
					enabled: true
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {string} fittingCaseName
	 * @return {Promise<string>}
	 */
	addFittingCase(fittingCaseName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/addFittingCase`, {
					fittingCaseName,
					enabled: true
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {string} aspectName
	 * @param {string} transformerName
	 * @param {Object} values
	 * @return {Promise<string>}
	 */
	addCalculate(id, aspectName, transformerName, values) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/addCalculate`, {
					id,
					aspectName,
					transformerName,
					values,
					enabled: true
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {number} aspectId
	 * @param {number} transformerId
	 * @param {Object} values
	 * @return {Promise<string>}
	 */
	addWhatIf(id, aspectId, transformerId, values) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/addWhatIf`, {
					id,
					aspectId: aspectId || null,
					transformerId: transformerId || null,
					values,
					enabled: true
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @return {Promise<any>}
	 */
	getQueueCounts() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/getQueueCounts`)
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<any>}
	 */
	getQueueCountByAspect(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getQueueCountByAspect`, { id })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {String} groupName
	 * @return {Promise<any>}
	 */
	listFiles(id, groupName) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/listFiles`, {
					id, groupName
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<any>}
	 */
	getResult(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getResult`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} taskManagerId
	* @param {string} name
	* @return {Promise<any>}
	*/
	getFileContent(taskManagerId, name) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getFileContent`, {
					taskManagerId,
					name
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} measurementId
	 * @param {number} readerId
	 * @param {Object} values
	 * @return {Promise<string>}
	 */
	addPiMeasurementReader(measurementId, readerId, values) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/addPiMeasurementReader`, {
					measurementId,
					readerId,
					values,
					enabled: true
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {string} id
	* @param {number} enabled
	* @return {Promise<any>}
	*/
	updateEnabled(id, enabled) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/updateEnabled`, {
					id,
					enabled
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @param {dto} dto
	* @return {Promise<any>}
	*/
	updateSchedule(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/updateSchedule`, {
					id,
					dto
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {string} name
	* @return {Promise<any>}
	*/
	clearState(name) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/clearState`, {
					name
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<any>}
	 */
	runOnDemand(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/runOnDemand`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

}

export default new TaskManagerService();
